import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "flex flex-col flex-1 overflow-hidden" }
const _hoisted_3 = { class: "flex flex-nowrap justify-between items-center" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "text-blue-600 text-xs font-medium" }
const _hoisted_6 = { class: "flex flex-nowrap justify-between items-center" }
const _hoisted_7 = { class: "text-sm text-gray-600 h-5 truncate flex-grow" }
const _hoisted_8 = {
  key: 0,
  class: "bg-yellow-400 rounded-full text-center text-gray-200 text-xs h-4 w-4",
  style: {"font-size":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {
      name: 'Messenger Conversation',
      params: { conversationId: _ctx.conversation.id }
    },
    class: "hover:bg-white transition-all bg-gray-100 duration-300 ease-in-out py-2 px-4 flex items-center justify-start"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.conversation.conversationImageUrl,
        alt: "",
        width: "40",
        class: "mr-4 rounded-full",
        height: "40"
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(`${_ctx.conversation.title}`), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatDate(_ctx.conversation.lastMessage.date)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.conversationSubitle), 1),
          (
            _ctx.conversation.unreadedMessages && _ctx.conversation.unreadedMessages > 0
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.conversation.unreadedMessages), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}